import { supabase } from "../supabase.js";
import { askStreaming } from "../ndjson.js";
import { describeTargets, profileForMapping, IMPORTABLE } from "./mapping.js";

/* Asking the server which column is which.
 *
 * Only the column names and a few sample values leave the browser. The rows
 * stay here and are mapped here. See mapping.js for why that is the design
 * rather than a saving.
 */

const ENDPOINT = "/.netlify/functions/map-workbook";

export async function mapWorkbook({ contractId, contract, sheets, registers = IMPORTABLE, onProgress }) {
  const { data: session } = await supabase.auth.getSession();
  const token = session?.session?.access_token;
  if (!token) throw new Error("Your session has expired. Sign in again.");

  const found = await askStreaming(ENDPOINT, {
    token,
    onProgress,
    what: "The column matching",
    body: {
      contractId,
      sheets: sheets.map((s) => profileForMapping(s)),
      targets: describeTargets(contract, registers),
    },
  });

  return Array.isArray(found.sheets) ? found.sheets : [];
}
